
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const AdvertiseFAQ = () => {
  const faqs = [
    {
      question: "Who sees my ads?",
      answer: "Local homeowners searching for services and the local service providers too. Our platform connects homeowners in Oklahoma City with trusted contractors and service professionals."
    },
    {
      question: "How long do ads run?",
      answer: "Ad duration depends on the package. Details provided upon request. We offer flexible options to meet your marketing needs and budget."
    },
    {
      question: "How do I get started?",
      answer: "Fill out the inquiry form below, and we'll be in touch within 1-2 business days to discuss your advertising options."
    },
    {
      question: "What types of businesses can advertise?",
      answer: "We welcome advertising from local businesses like realtors, restaurants, retail stores, and other local establishments serving the Oklahoma City area."
    },
    {
      question: "Do you offer design services for ads?",
      answer: "Yes, we can assist with basic ad design or provide specifications for your marketing team. We're committed to helping your ad perform well."
    }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-primary mb-10">
            Frequently Asked Questions
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-b border-muted">
                <AccordionTrigger className="text-lg font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
};
